// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1E8zr","loaderOuter":"PageOverlayLoader_loaderOuter__3UzQN"};